const en: TranslationKeys = {
  bets: "bets",
  BookingCode: "Booking Code",
  "BetSlipStatus-1": "Suspended",
  "BetSlipStatus-2": "Closed",
  BetBuilderIncompatibleSelections:
    "This selection cannot be combined with some of the rest of your selections.",
  BetBuilderSelectionsLimit:
    "You have reached the maximum number of selections in a Bet Builder!",
  BetBuilderCombinableLimit:
    "You have reached the maximum number of Bet Builders in a bet!",
  BetSlipAcceptChanges: "Accept Odds Changes",
  BetSlipAcceptChangesInformation: "Higher odds are automatically accepted",
  BetSlipBetAuthorizationTitle: "Bet In Process",
  BetSlipBetAuthorizationTitle2: "Bet Declined",
  BetSlipBetAuthorizationTitle3: "Confirm Changes",
  BetSlipBetDeclined:
    "<h3>This bet cannot be placed</h3><h3>at the moment, please try again later.</h3><button id='declined-betting' class='au-m-btn accent'>Continue Betting</button>",
  BetSlipBetInProcess:
    "<h3>Please wait for confirmation</h3><div class='timer au-m-ico-c' style='background-image: url(assets/sport/{layout}-clock.svg)'><span class='seconds'>{remainingTime}</span><span class='label'>sec</span></div><div><button id='cancel-bet' class='au-m-btn inverse danger'>Cancel Bet</button></div>",
  BetSlipBetInProcessLite:
    "<h3>Please wait for confirmation</h3><div><button id='refresh-popup' class='au-m-btn accent'>Refresh <span class='seconds'>{remainingTime}</span><span class='label'>sec</span></button><button id='cancel-bet' class='au-m-btn inverse danger'>Cancel Bet</button></div>",
  BetSlipBetSuccessContinueBetting: "Continue Betting",
  BetSlipBetSuccessIntroInformation:
    "<h3 class='p-b'>Your bet was successfully submitted</h3><h3 class='txt-b'>Bet ID: {betId}</h3>",
  BetSlipBetSuccessPlacedTable:
    "<span class='au-m-mod-b-tbl'><span><h5>Stake</h5><h5>{bs.grossStake} {currency}</h5></span>{bs.hasET:if|BetSlipBetSuccessPlacedTableET}{bs.hasETNetStake:if|BetSlipBetSuccessPlacedTableNetStake}{bs.hasETNetTotalStake:if|BetSlipBetSuccessPlacedTableNetTotalStake}{bs.totalO:if|BetSlipBetSuccessPlacedTableTO}{bs.hasOB:if|BetSlipBetSuccessPlacedTableOB}<span><h5>Max Payout</h5><h5>{bs.maxPO} {currency}</h5></span></span>",
  BetSlipBetSuccessPlacedTableOB:
    "<h5>Win Boost ({bs.bonus.bonusPercent}%)</h5><h5>{bs.bonus.bonusValue} {currency}</h5>",
  BetSlipBetSuccessPlacedTableTO: "<h5>Total Odds</h5><h5>{totalOdds}</h5>",
  BetSlipBetSuccessPlacedTableNetStake:
    "<h5>Net Stake</h5><h5>{bs.totalStake} {currency}</h5>",
  BetSlipBetSuccessPlacedTableNetTotalStake:
    "<h5>Net Total Stake</h5><h5>{bs.totalStake} {currency}</h5>",
  BetSlipBetSuccessPlacedTableET:
    "<h5>VAT ({bs.exciseTax}%)</h5><h5>{bs.exciseTaxValue} {currency}</h5>",
  BetSlipBetSuccessRebet: "Re-Use Selections",
  BetSlipBonusBoost:
    "Win Boost ({bonusPercent}%) <span>{bonusValue} {currency}</span>",
  BetSlipBonusStakeMinInformation:
    "{bonus.status:if-ne|8|BetSlipBonusStakeMinInformationSA}",
  BetSlipBonusStakeMinInformationSA:
    "{bonus.WagerMinStakeAmount:if|BetSlipBonusStakeMinInformationSAW|BetSlipBonusStakeMinInformationSAB} {currency}",
  BetSlipBonusStakeMinInformationSAB:
    "Min bonus stake is {bonus.minStakeAmount}",
  BetSlipBonusStakeMinInformationSAW:
    "Min wagering stake is {bonus.WagerMinStakeAmount}",
  BetSlipBookBet: "BOOK A BET",
  BetSlipBookCopied: "Copied",
  BetSlipBookCopy: "Copy",
  BetSlipBookSuccessContinueBetting: "Ok",
  BetSlipBookSuccessDescription: "Booking Code Successfully Generated",
  BetSlipBookSuccessExpirationTimeConfiguration:
    "The booking code is valid for the next '{validTime}' hour{validTime:if-gt|1|<span style='color:black'>s</span>}",
  BetSlipBookSuccessTitle: "Booking a Bet",
  BetSlipShareBet: "Share your bet:",
  BetSlipComboLabel: "<div>Stake</div><div>{bets} selections</div>",
  BetSlipComboStake: "Stake",
  BetSlipConfirmChanges:
    "<h3 class='m-b'>The ticket isn't allowed<br>due to site policy, please confirm<br>the changes to place a bet.</h3>{betStatusMessage.stats.single:if|BetSlipConfirmChangesSingle}{betStatusMessage.stats.combo:if|BetSlipConfirmChangesCombo}<div class='au-m-mod-b-tbl'>{betStatusMessage.stats.noExciseTax:if|BetSlipConfirmChangesTaxExcise}{betStatusMessage.stats.noTax:if|BetSlipConfirmChangesTax}<span><h5><strong>Max Payout:</strong></h5><h5><strong>{maxPayout} {currency}</strong></h5></span></div><button id='confirm-changes' class='au-m-btn accent'>Confirm And Place Bet</button><button id='refuse-bet' class='au-m-btn inverse danger'>Cancel Bet</button>",
  BetSlipConfirmChangesCombo:
    "<div class='table-box'><div class='c-grid'><span class='grid-33 table-header'>&nbsp;</span><span class='grid-33 table-header'>Original</span><span class='grid-33 table-header'>New</span>{betStatusMessage.stats.totalOdds:if|BetSlipConfirmChangesComboOdds}{betStatusMessage.stats.oldStake:if|BetSlipConfirmChangesComboStake}</div></div>",
  BetSlipConfirmChangesComboOdds:
    "<span class='grid-33 table-row'>Total Odds</span><span class='grid-33 table-row'>{oldOdds}</span><span class='grid-33 table-row'>{totalOdds}</span>",
  BetSlipConfirmChangesComboStake:
    "<span class='grid-33 table-row'>Total Stake</span><span class='grid-33 table-row'>{betStatusMessage.stats.oldStake} {currency}</span><span class='grid-33 table-row'>{totalStake} {currency}</span>",
  BetSlipConfirmChangesSingle:
    "{betStatusMessage.changes:for|BetSlipConfirmChangesSingleData}",
  BetSlipConfirmChangesSingleData:
    "<span class='game'>{homeName} vs {awayName}</span><div class='table-box'><div class='c-grid'><span class='grid-33 table-header'>&nbsp;</span><span class='grid-33 table-header'>Original</span><span class='grid-33 table-header'>New</span>{notComboStakeChanged:if|BetSlipConfirmChangesSingleStake}{oddsChanged:if|BetSlipConfirmChangesSingleOdds}</div></div>",
  BetSlipConfirmChangesSingleOdds:
    "<span class='grid-33 table-row'>Odds</span><span class='grid-33 table-row'>{oldOdd}</span><span class='grid-33 table-row'>{newOdd}</span>",
  BetSlipConfirmChangesSingleStake:
    "<span class='grid-33 table-row'>Stake</span><span class='grid-33 table-row'>{oldStake} {currency}</span><span class='grid-33 table-row'>{newStake} {currency}</span>",
  BetSlipConfirmChangesTax:
    "<h5>Winning Tax ({betStatusMessage.stats.taxRate}%):</h5><h5>{tax} {currency}</h5>",
  BetSlipConfirmChangesTaxExcise:
    "<h5>VAT ({betStatusMessage.stats.exciseTaxRate}%):</h5><h5>{exciseTax} {currency}</h5>",
  BetSlipEventLiveTime: "<span>LIVE</span>",
  BetSlipExciseTax: "VAT ({tax}%) <span>{taxValue} {currency}</span>",
  BetSlipHomeAway: "{selectionsHome:span}{selectionsAway:span}",
  BetSlipLoginToBet: "LOGIN TO BET",
  BetSlipMaxPayOut:
    "<div class='maxPayout'>Max Payout <span>{maxPayOut} {currency}</span></div>",
  BetSlipMinStakeInformation:
    "<div class='min-stake' >Min Stake is {minBet}</div>",
  // "BetSlipNoSelectionsExplanation": "<i class='au-m-ico-c au-i-new-empty-betslip new-empty-betslip'></i> <h2> Your Betslip Is Empty </h2><p> Please add some selections <br> to place a bet.</p>",
  BetSlipPlaceBet: "PLACE A BET",
  BetSlipBetPlaced: "Bet Success!",
  BetSlipBetPlacedExplanation: "Your bet was successfully submitted.",
  BetSlipBetPlacedID: "<h3 class='txt-b'>Bet ID: {betId}</h3>",
  BetslipBetPlacedModalTitle: "Share My Bet",
  BetSlipPlaceBetButton: "{canPlace:if|BetSlipPlaceBet|BetSlipProcessingBet}",
  // "BetSlipProcessingBet": "PROCESSING BET {betTimeOut:if_bet-timeout|BetSlipProcessingBetTimeOut} <i class='icon-spinner au-m-ico-l' style='background-image:url(assets/sport/loader.svg);'></i>",
  BetSlipProcessingBetTimeOut: "{betTimeOut}s",
  loadBetSelectionChanges: "Some of your selections are no longer available",
  BetSlipRemoveAll: "Remove All {trash-gsb:icon}",
  BetSlipSingleLabel:
    "<div>Stake per selection</div><div>{bets} selections</div>",
  BetSlipSingleStake: "Stake",
  BetSlipStakeAmountVsAmountNotMetCombo:
    "<span class='txt-danger'>Please insert a stake</span>",
  BetSlipStakeAmountVsAmountNotMetSingle:
    "<span class='txt-danger'>Please insert a stake in ticket/s</span>",
  BetSlipStakeAmountVsLowerThanAllowedAmount:
    "<span class='txt-danger'>Min stake amount allowed is {minBet}</span>",
  BetSlipStakeAmountVsGreaterThanAllowedAmount:
    "<span class='txt-danger'>You have reached the maximum stake {maxBet} {currency}<br/>Please change the stake</span>",
  BetSlipStakeErrorPopup:
    "<h1>Bet Not Complete </h1><p>You don't have enough money in your<br />account to place this bet.<br /></p><p>Please make a deposit or lower your stake</p><p><button class='au-m-btn positive' id='deposit'>Deposit</button><br /><button class='au-m-btn' id='back'>Back</button></p>",
  BetSlipStakeErrorPopupNoEnoughMoney:
    "<h1>Bet Not Complete</h1><p>Not enough balance - make a deposit or update your stake</p><p><button class='au-m-btn positive' id='deposit'>Deposit</button><br /><button class='au-m-btn' id='back'>Back</button></p>",
  "BetSlipStakeErrorPopupNoEnoughMoney-popup":
    "<h3>It seems you don’t have</h3><h3>enough money.</h3><h3>You can lower the stake amount</h3><h3>OR make a deposit.</h3><button class='au-m-btn accent' id='deposit'>Deposit</button>",
  BetSlipStakeMinInformation: "Minimum stake {minBet} {currency}",
  BetSlipTotalOdds: "Total Odds {totalOdds:span}",
  BetSlipTotalStake: "Total Stake {receiptStake:span}",
  BetSlipNetStake: "Net Stake <span>{receiptNetStake} {currency}</span>",
  BetSlipTotalNetStake:
    "Net Total Stake <span>{receiptNetStake} {currency}</span>",
  BetSlipUseFrb: "Use Free Bet",
  SelectFrbBonus: "Select Free Bet",
  NotEligibleFrb: "Betslip not yet qualified for Free Bet",
  BetSlipUseFrbInformation: "Check the box to apply your Freebets",
  BetslipMaxSelections:
    "<span class='txt-danger'>You have reached the maximum {limit} selections<br/>Please change the selections</span>",
  BonusRulesChanged: "Bonus rules have changed",
  ChangesInBetslipTryAgain: "Changes in Betslip. Please try again.",
  MaxPaymentLimit: "Bet exceeds payout limit with recent similar bets.",
  OrderValidationError: "Free bet bonus has already been used",
  InvalidBetslipCode: "This code is expired or invalid.",
  LockedUserCannotPlaceBet:
    "<span class='txt-danger'>You cannot place a bet, <br/> please contact the support.</span>",
  LoadBetButton: "LOAD",
  NoMatchesAvailable:
    "All selections are no longer available.Please try a different code.",
  NoTaxPercentage: "Winning Tax <span>{taxValue} {currency}</span>",
  PleaseTryAgainLater:
    "Server Response: An error occurred please try again later.",
  TaxPercentage: "Winning Tax ({tax}%)<span>{taxValue} {currency}</span>",
  TaxRefundPercentage: "Tax Refund ({tax}%)<span>{taxValue} {currency}</span>",
  TotalOddsLimit:
    "Max odds total exceeded, please remove selections to continue.",
  SeoBonusTemplate0StakeError: "Your bet slip does not qualify for this bonus!",
  SeoBonusDescription10Plural:
    "Congrats! {bonus.minSelection} selections give you a {bonus.bonusPercent}% Win Boost.",
  SeoBonusDescription10Singular:
    "Congrats! {bonus.minSelection} selection gives you a {bonus.bonusPercent}% Win Boost.",
  SeoBonusTemplateTeasersNextBonusHigher:
    "Add {bonuses.nextBonus.selectionToAdd} more with min odds of {bonuses.nextBonus.minOddPerRow} for {bonuses.nextBonus.bonusPercent}% extra.",
  SeoBonusTemplateTeasersNextBonusTipPlural:
    "Add {bonuses.nextBonus.selectionToAdd} more selections with min odds of {bonuses.nextBonus.minOddPerRow} for {bonuses.nextBonus.bonusPercent}% extra.",
  SeoBonusTemplateTeasersNextBonusTipSingular:
    "Add {bonuses.nextBonus.selectionToAdd} more selection with min odds of {bonuses.nextBonus.minOddPerRow} for {bonuses.nextBonus.bonusPercent}% extra.",
  SeoBonusTemplateContentStakeError:
    "Your min stake needs to be {bonus.nextBonus.minStakeAmount} to qualify for the Win Bonus.",
  AuthenticationRegisterButton:
    "Don't have an account? <a href='{cultureUrl}/authentication/register'>Join Now</a>",
  BetSlipStakeErrorPopupNoEnoughMoneytitle: "Oops...",

  // New BetSlipWidget Translations
  BetSlipWidgetNoSelectionsExplanationHeader: "Your Betslip Is Empty",
  BetSlipWidgetNoSelectionsExplanationText:
    "Please add some selections to place a bet.",
  BetSlipWidgetProcessingBet: "PROCESSING BET",
  BetSlipWidgetCancelBet: "Cancel Bet",
  BetSlipWidgetWaitForConfirmation: "Please wait for confirmation",
  BetSlipWidgetFrbMinOdds: "Min Odds",
  BetSlipWidgetFrbMinSelections: "Min Selections",
  BetSlipWidgetBetDeclinedMessage:
    "This bet cannot be placed at the moment, please try again later.",
  BetSlipWidgetBetDeclinedContinue: "Continue Betting",
  BetSlipWidgetConfirmChangesTitle:
    "The ticket isn't allowed due to site policy, please confirm the changes to place a bet.",
  BetSlipWidgetConfirmAndPlaceBet: "Confirm And Place Bet",
  BetSlipWidgetConfirmChangesOriginal: "Original",
  BetSlipWidgetConfirmChangesNew: "New",
  BetSlipWidgetWinningTax: "Winning Tax",
  BetslipWidgetSelectionsLimit:
    "You have reached the maximum {limit} selections. Please change your selections.",
  BetslipWidgetAuthenticationRegisterButtonText: "Don't have an account?",
  BetslipWidgetAuthenticationRegisterButtonJoinNowText: "Join Now",
};

export default en;
